"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedVariantSuggestionList = instanceOfPaginatedVariantSuggestionList;
exports.PaginatedVariantSuggestionListFromJSON = PaginatedVariantSuggestionListFromJSON;
exports.PaginatedVariantSuggestionListFromJSONTyped = PaginatedVariantSuggestionListFromJSONTyped;
exports.PaginatedVariantSuggestionListToJSON = PaginatedVariantSuggestionListToJSON;
exports.PaginatedVariantSuggestionListToJSONTyped = PaginatedVariantSuggestionListToJSONTyped;
const variantSuggestion_1 = require("./variantSuggestion");
/**
 * Check if a given object implements the PaginatedVariantSuggestionList interface.
 */
function instanceOfPaginatedVariantSuggestionList(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    if (!('next' in value) || value['next'] === undefined)
        return false;
    if (!('previous' in value) || value['previous'] === undefined)
        return false;
    if (!('results' in value) || value['results'] === undefined)
        return false;
    return true;
}
function PaginatedVariantSuggestionListFromJSON(json) {
    return PaginatedVariantSuggestionListFromJSONTyped(json, false);
}
function PaginatedVariantSuggestionListFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
        'next': json['next'],
        'previous': json['previous'],
        'results': (json['results'].map(variantSuggestion_1.VariantSuggestionFromJSON)),
    };
}
function PaginatedVariantSuggestionListToJSON(json) {
    return PaginatedVariantSuggestionListToJSONTyped(json, false);
}
function PaginatedVariantSuggestionListToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': (value['results'].map(variantSuggestion_1.VariantSuggestionToJSON)),
    };
}
//# sourceMappingURL=paginatedVariantSuggestionList.js.map